<!--

    * App.svelte
    This is the root of the website. It is also where all the pages are structured and constructed.
	All routes are defined below and are based on the svelte-routing package.
    ! Warning: Incorrectly configured routes can break entire page urls (Proceed with caution)

-->

<script lang="ts">
	import { Router, Route } from "svelte-routing";
	/* Static components */
	import Header from "./components/header.svelte";
	import Nav from "./components/nav.svelte";
	import Footer from "./components/footer.svelte";
	/* Routes (Pages) */
	import HomeRoute from "./routes/home.svelte";
	import AboutRoute from "./routes/about.svelte";
	import ContactRoute from "./routes/contact.svelte";
	import PublicationsRoute from "./routes/publications.svelte";
	import ToolsRoute from "./routes/tools.svelte";
	import CollaborationsRoute from "./routes/collaborations.svelte";
	import PeopleRoute from "./routes/people.svelte";
	import ProfilePageRoute from "./routes/profile.svelte";
	import ResearchComponent from "./routes/research.svelte";
	import ResearchDetailsComponent from "./routes/research-details.svelte";
	import MajorProjectsComponent from "./routes/major-projects.svelte";
	/* 404 Error Page Route */
	import ErrorPageRoute from "./404.svelte";

	let homeComponent;

</script>

<Header/>
<Nav on:researchAnchorClicked={homeComponent.scrollToResearchAnchor} />

<Router>
	<Route path="/"><HomeRoute bind:this={homeComponent}/></Route>
	<Route path="projects/:activeCategory/:activeSubCategory" component="{ResearchComponent}"/>
		<Route path="project/:id" component="{ResearchDetailsComponent}"/>
	<Route path="major-projects/:id" component="{MajorProjectsComponent}"/>
	<Route path="publications" component="{PublicationsRoute}"/>
	<Route path="collaborations" component="{CollaborationsRoute}"/>
	<Route path="tools" component="{ToolsRoute}"/>
	<Route path="people" component="{PeopleRoute}"/>
		<Route path="profile/:id" component="{ProfilePageRoute}"/>
	<Route path="contact" component="{ContactRoute}"/>
	<Route path="about" component="{AboutRoute}"/>
	<Route path="*" component="{ErrorPageRoute}"/>
</Router>

<Footer/>